module.exports = __webpack_public_path__ + "media/app/assets/races/lightforged_draenei_female-4674b6b3911109a07e9360c9b158ad40.png";